<template>
  <div class="action-tray" id="action-template-tray" :class="{ active: show }" ref="tray">
    <div class="key-actions">
      <a
        class="key-action priority"
        :class="action.priority"
        @click.stop="togglePrioritiesVisible()"
        v-tooltip="{ content: `Set priority`, delay }"
      ></a>
      <priority-picker
        :level="action.priority"
        :visible="priorities_visible"
        v-click-outside="setPrioritiesInvisible"
        :changePriority="changePriority"
      />

      <!--      <a-->
      <!--        class="key-action delete"-->
      <!--        @click="deleteAction()"-->
      <!--        v-tooltip="{ content: `Delete`, delay }"-->
      <!--      ></a>-->
    </div>

    <a class="close" @click="close()"><i class="material-icons">clear</i></a>

    <textarea
      class="title flexi-textarea"
      v-model="action.title"
      v-autosize="action.title"
      placeholder="Add a title"
      rows="1"
      maxlength="256"
      @blur="updateTitle"
      ref="title"
    ></textarea>

    <h4 class="label">Notes</h4>
    <textarea
      class="description flexi-textarea"
      v-model="action.description"
      v-autosize="action.description"
      placeholder="Add a description"
      max-rows="5"
      maxlength="512"
      @blur="updateDescription"
      ref="description"
    ></textarea>

    <div class="flex-between">
      <div class="half">
        <h4 class="label">Type</h4>
        <data-select
          type="action"
          :changeHandler="updateType"
          :filterIds="[]"
          :value="action_types[action.type]"
        />
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center">
      <h4 class="label d-flex justify-content-between align-items-center">
        Resources
      </h4>
      <a
        class="icon label pr-3"
        v-tooltip="{ content: 'Upload link/document', delay: 200 }"
        style="cursor: pointer;"
        id="add-resource-btn"
        @click="show_resource_options()"
      >
        <img src="~@/assets/icons/plus-grey.svg" height="16px" width="16px"/>
      </a>
    </div>

    <div class="list" v-if="action.resources">
      <div
        class="item link"
        v-for="(resource, i) in action.resources"
        :key="i"
        @click="openLink(resource.url)"
      >
        <a class="icon other" :class="'other'"></a>
        <img class="go" src="~@/assets/icons/go.svg"/>
        <div class="stack">
          <h6>{{ resource.title }}</h6>
          <span class="desc">{{ resource.url }}</span>
          <a class="click">{{ resource.type === 'doc' ? 'Click to download' : 'Click to open' }}</a>
        </div>
      </div>
    </div>
    <div v-if="newLink">
      <material-input
        class="mb-2"
        v-model="newLink.title"
        type="text"
        label="Link title"
        :required="true"
        name="LinkDescription"
      />
      <material-input
        class="mb-2"
        v-model="newLink.url"
        type="text"
        label="URL"
        :required="true"
        name="LinkURL"
      />
      <div class="ml-2">
        <icon-arrow-up
          style="cursor: pointer"
          @click="addNewLink"
          font-scale="1.2"
        />
        <icon-x-circle
          style="cursor: pointer"
          @click="newLink = null"
          font-scale="1.2"
        />
      </div>
    </div>

    <SecureFileUpload />
  </div>
</template>

<script>
import Vue from 'vue';
import DataSelect from '../components/DataSelect';
import PriorityPicker from '../components/PriorityPicker';
import MaterialInput from './MaterialInput';
import { BIconArrowUpSquare, BIconXCircle } from 'bootstrap-vue';
import SecureFileUpload from "./SecureFileUpload";

export default {
  name: 'ActionTemplateTray',
  components: {
    SecureFileUpload,
    'data-select': DataSelect,
    'priority-picker': PriorityPicker,
    'material-input': MaterialInput,
    'icon-arrow-up': BIconArrowUpSquare,
    'icon-x-circle': BIconXCircle,
  },
  props: {
    action: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      priorities_visible: false,
      delay: {show: 700, hide: 0},
      saving: false,
      templates: {
        ['Plan negotiation']: {
          notes: 'Planning should take the majority of your time during a negotiation. Use the template negotiation plan below to prepare for your negotiation.',
          resources: [
            {
              type: 'doc',
              title: 'Negotiation Plan Template',
              url: 'https://acada-demo-doc-bucket.s3.eu-west-2.amazonaws.com/Negotiation+Plan.xlsx'
            }
          ]
        },
        ['Issue NDAs']: {
          notes: 'NDA should be put in place with all parties invited to the tender. Use the link below to quickly create a mutual NDA.',
          resources: [
            {
              type: 'link',
              title: 'NDA Generator',
              url: 'https://docs.google.com/forms/d/e/1FAIpQLScgj_Ch7iFV3_CZUse3LMV-ghwfs7-bXIjqUh0Es77_VHEbVA/viewform?vc=0&c=0&w=1&flr=0&dods&gxids=7628'
            }
          ]
        },
        ['Identify stakeholders']: {
          notes: 'Identify Stakeholders. Use the email template to invite them into the process and map onto the Stakeholder Map Template below.',
          resources: [
            {
              type: 'doc',
              title: 'Stakeholder Map Template',
              url: 'https://acada-demo-doc-bucket.s3.eu-west-2.amazonaws.com/Stakeholder+Map.pot'
            },
            {
              type: 'doc',
              title: 'Kick-off meeting email template',
              url: 'https://acada-demo-doc-bucket.s3.eu-west-2.amazonaws.com/Stakeholder+kick-off+meeting.emltpl'
            }
          ]
        }
      },
      newLink: null
    };
  },
  computed: {
    app_user() {
      return this.$store.getters.app_user;
    },
    action_types() {
      return this.$store.getters.action_types;
    },
    show() {
      return !!this.action;
    },
  },
  methods: {
    clickOutside() {
      this.close();
    },
    close() {
      if (this.action) {
        this.$emit('dismissed')
      }
    },
    updateTitle() {
    },
    updateDescription() {
    },
    updateType(type, mode) {
      Vue.set(this.action, 'type', type.value);
    },
    toggleComplete() {
      Vue.set(this.action, 'completed', !this.action.completed);
      this.saveChanges();
    },
    togglePrioritiesVisible() {
      this.priorities_visible = !this.priorities_visible;
    },
    setPrioritiesInvisible() {
      this.priorities_visible = false;
    },
    changePriority(priority) {
      Vue.set(this.action, 'priority', priority);
      this.setPrioritiesInvisible();
    },
    async deleteAction() {
    },
    openLink(url) {
      url = url.match(/^http[s]?:\/\//) ? url : 'https://' + url;
      window.open(url, '_blank').focus();
    },
    show_resource_options() {
      this.$store.dispatch('setOverflowDropShowing', false);

      const rect = document
        .getElementById(`add-resource-btn`)
        .getBoundingClientRect();

      const {left: mainViewLeft} = document.querySelector('#main-view').getBoundingClientRect();

      this.$store.dispatch('setOverflowDropPosition', {
        top: rect.top,
        left: rect.left + mainViewLeft - 180,
      });

      const addLinkHandler = () => {
        this.newLink = {}
        Object.assign(this.newLink, {
          url: '',
          title: '',
          type: 'other'
        })
      }

      const uploadDocHandler = () => {
        console.log('Upload document')
      }

      this.$store.dispatch('setOverflowOptions', [
        {
          label: 'Add link',
          handler: addLinkHandler
        },
        {
          label: 'Upload document',
          handler: uploadDocHandler
        }]);

      this.$store.dispatch('setOverflowItemId', 'add-resource-btn');

      this.$nextTick(() => this.$store.dispatch('setOverflowDropShowing', true))
    },
    addNewLink(){
      if(!this.newLink) return;
      if(!this.action.resources || !Array.isArray(this.action.resources)) this.action.resources = []
      this.action.resources.push(this.newLink)
      this.newLink = null
    }
  },
  watch: {
    action(val) {
      this.$refs.tray.scrollTo(0, 0);
    },
  },
};
</script>
<!--TODO - Add Scoped-->
<style lang="scss" scoped> // TODO - Should this be scoped?
@import '../styles/_styles.scss';

.action-tray {
  position: fixed;
  top: 80px;
  right: -380px;
  transition: right 0.6s;
  border-left: 1px solid $border-color;
  padding: 37px 25px;

  height: calc(100% - 80px);
  width: 375px;
  background: #f9fafc;
  pointer-events: none;

  overflow-y: auto;

  &.active {
    right: 0;
    pointer-events: auto;
  }

  .close {
    position: absolute;
    top: 40px;
    right: 22px;
    cursor: pointer;
    user-select: none;
    height: 24px;
  }

  .flexi-textarea.title {
    font-size: 24px;
    color: #26292f;
    font-weight: 500;
    margin: 0;
    width: 100%;
    line-height: normal;
  }

  .label {
    color: #26292f;
    font-size: 16px;
    font-weight: 500;
    margin-top: 25px;
    margin-bottom: 15px;

    span {
      color: #c6d0db;
    }

    + .action-btn {
      margin-top: 35px;
      margin-bottom: 15px;
      cursor: pointer;
    }
  }

  .key-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 30px;
    position: relative;

    .key-action {
      border-radius: 15px;
      width: 30px;
      height: 30px;
      margin-right: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: top left;

      img {
        width: 12px;
        height: auto;
      }

      &.priority {
        background-image: url(~@/assets/icons/priorities.svg);
        background-size: 120px 30px;

        &.Low {
          background-position: top left -30px;
        }

        &.Medium {
          background-position: top left -60px;
        }

        &.High {
          background-position: top left -90px;
        }
      }

      &.completion {
        background-image: url(~@/assets/icons/completion.svg);
        background-size: 60px 30px;

        &.completed {
          background-position: top left -30px;
        }
      }

      &.delete {
        background-image: url(~@/assets/icons/trash.svg);
        background-size: 30px 30px;
      }
    }
  }

  .flexi-textarea {
    border-color: transparent;
    outline: none;
    width: 100%;
    background: transparent;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    resize: none;
    transition: border 0.2s;

    &:hover {
      border-bottom-color: #dbdee5;
      resize: auto;
    }

    &:active,
    &:focus {
      border-bottom-color: #b6bac4;
      resize: auto;
    }
  }

  .data-select {
    margin-bottom: 0;
  }

  .datepicker,
  .datepicker .datepicker-input {
    max-width: 100%;

    > .popover-origin > .popover-content-wrapper > .popover-content {
      left: -110px;

      &:after {
        left: 130px !important;
      }
    }
  }

  .half {
    width: 50%;

    .data-select {
      width: 100%;

      .add {
        width: calc(100% - 10px);
        margin-right: 10px;
      }
    }
  }
}

.datepicker {
  margin-top: -15px;
}

.dropdown {
  margin-top: 10px;
}

.projectName,
.actionName {
  cursor: pointer;
  font-weight: 400;
  padding-left: 3px;
  font-size: 16px;
  margin-top: 20px;
  color: #acb6c1;
  position: relative;
  width: 100%;

  img {
    position: relative;
    top: -0px;
    margin-right: 5px;

    &.go {
      opacity: 0;
      transition: opacity 0.3;
    }
  }

  &:hover {
    img.go {
      opacity: 1;
    }
  }
}

.actionName {
  font-size: 14px;
  margin-top: 15px;
}
</style>
